import { createAppUseApiHook } from '@hwm/ui-lib';
import { httpClient } from './HttpClient';

export const useApi = createAppUseApiHook(httpClient);
